<template>
    <div class="topBanner">
        <div class="topBannerColor">
        </div>
    </div>
</template>
<style scoped>
  .topBanner {height: 500px; background-image: url('../../public/Resource/Banner/bannerDemonstration.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover;}
  .topBannerColor { height: 500px; width: 100%; background-color: rgba(var(--secondary),0.5);}


  @media handheld, only screen and (max-width: 600px) {}
  @media handheld, only screen and (max-width: 960px) {}
  @media handheld, only screen and (max-width: 1264px) {}  
</style>
<script>
  export default {
    name: 'Banner',
    data: () => ({

    }),
    
    mounted() {

    },
    methods:{

    },
    component: {

    }
    
  }
</script>